import { render, staticRenderFns } from "./ReceptionComponent.vue?vue&type=template&id=33e89036&"
import script from "./ReceptionComponent.vue?vue&type=script&lang=js&"
export * from "./ReceptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports